<!-- style="margin-left: 20%;" -->
<template>
  <div  
    class="h-full inl-80 overflow-y-scroll scroll-styling w-100 mx-auto px-4">
    <h1 class="text-3xl font-bold mb-8 text-center text-gray-900 mt-5">Мой профиль</h1>

    <form @submit.prevent="saveProfile" class="bg-white p-6 rounded-xl shadow-md">
      <div class="grid gap-6 mb-6 md:grid-cols-2">

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900">ФИО</label>
          <input v-model="profile.fio" type="text" placeholder="ФИО" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900">Логин</label>
          <input v-model="profile.login" type="text" placeholder="Логин" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900">Email (опционально)</label>
          <input v-model="profile.email" type="email" placeholder="Email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900">Телефон</label>
          <input v-model="profile.phone" type="tel" placeholder="+7xxxxxxxxxx" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
          <small class="text-gray-500">Формат: +7xxxxxxxxxx</small>
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900">Дата рождения</label>
          <input v-model="profile.birth_date" type="date" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900">Роль</label>
          <input :value="user.role.val" type="text" disabled class="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed" />
        </div>

        <div>
          <label class="block mb-2 text-sm font-medium text-gray-900">Новый пароль</label>
          <div class="relative">
            <input
              v-model="profile.password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Новый пароль"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
            <PasswordVisibilityToggle
              :visible="showPassword"
              @toggle="showPassword = !showPassword"
            />
          </div>
        </div>

        <template v-if="user.role.key === 2">
          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Специализация</label>
            <input v-model="profile.expert_profile.specialization" type="text" placeholder="Специализация" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
          </div>

          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Образование</label>
            <textarea
              v-model="profile.expert_profile.education"
              rows="3"
              placeholder="Образование"
              :class="getExpertTextFieldClass('education')"
            ></textarea>
            <div :class="getExpertTextCounterClass('education')">
              {{ getExpertTextLength('education') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('education')" class="text-red-500">{{ getExpertTextError('education') }}</small>
          </div>

          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Фото</label>
            <input type="file" @change="handlePhotoUpload" accept="image/*" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
            <div v-if="photoPreview" class="mt-2">
              <img :src="photoPreview" alt="Фото" class="w-24 h-24 object-cover rounded-full shadow-md border" />
            </div>
          </div>

          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Биография</label>
            <textarea
              v-model="profile.expert_profile.bio"
              rows="3"
              :class="getExpertTextFieldClass('bio')"
              placeholder="Биография"
            ></textarea>
            <div :class="getExpertTextCounterClass('bio')">
              {{ getExpertTextLength('bio') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('bio')" class="text-red-500">{{ getExpertTextError('bio') }}</small>
          </div>

          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Опыт</label>
            <textarea
              v-model="profile.expert_profile.experience"
              rows="3"
              :class="getExpertTextFieldClass('experience')"
              placeholder="Опыт"
            ></textarea>
            <div :class="getExpertTextCounterClass('experience')">
              {{ getExpertTextLength('experience') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('experience')" class="text-red-500">{{ getExpertTextError('experience') }}</small>
          </div>

          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Достижения</label>
            <textarea
              v-model="profile.expert_profile.achievements"
              rows="3"
              :class="getExpertTextFieldClass('achievements')"
              placeholder="Достижения"
            ></textarea>
            <div :class="getExpertTextCounterClass('achievements')">
              {{ getExpertTextLength('achievements') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('achievements')" class="text-red-500">{{ getExpertTextError('achievements') }}</small>
          </div>

          <div></div>

          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Короткое описание</label>
            <textarea
              v-model="profile.expert_profile.preview_text"
              rows="2"
              style="min-height: 100px;"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Краткое описание/превью"
            ></textarea>
          </div>

          <div>
            <label class="block mb-2 text-sm font-medium text-gray-900">Полное описание</label>
            <vue-editor
              v-model="profile.expert_profile.content"
              :editor-toolbar="customToolbar"
              :class="['bg-white', isExpertTextFieldInvalid('content') && 'border border-red-500 rounded-lg']"
            ></vue-editor>
            <div :class="getExpertTextCounterClass('content')">
              {{ getExpertTextLength('content') }} / {{ expertTextMaxLength }}
            </div>
            <small v-if="getExpertTextError('content')" class="text-red-500">{{ getExpertTextError('content') }}</small>
          </div>
        </template>

      </div>

      <div v-if="user.role.key === 2" class="border-t-2 pt-6 mt-8">
        <h3 class="text-lg font-bold mb-4">Информация о пилоте</h3>

        <!-- Not pilot, not pending - can submit for verification -->
        <div v-if="!profile.expert_profile.is_pilot && !profile.expert_profile.is_pilot_pending_verification" class="bg-blue-50 p-4 rounded-lg border border-blue-200">
          <p class="mb-4 text-gray-700">Отправьте запрос на проверку статуса пилота</p>

          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900">Категория пилота</label>
            <select
              v-model="pilotVerificationData.pilot_category"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            >
              <option disabled value="">Выберите категорию</option>
              <option value="first">Первая категория</option>
              <option value="second">Вторая категория</option>
              <option value="third">Третья категория</option>
            </select>
          </div>

          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900">Сертификат пилота (PDF/JPG)</label>
            <input
              type="file"
              @change="handlePilotCertificateUpload"
              accept=".pdf,.jpg,.jpeg,.png"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
          </div>

          <button
            type="button"
            @click="submitPilotVerification"
            class="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-6 rounded-lg"
          >
            Отправить на проверку
          </button>
        </div>

        <!-- Pending verification -->
        <div v-else-if="profile.expert_profile.is_pilot_pending_verification" class="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
          <p class="text-yellow-800 font-semibold">⏳ На проверке</p>
          <p class="text-yellow-700 text-sm mt-1">Ваш запрос на проверку статуса пилота находится на рассмотрении модератора</p>
        </div>

        <!-- Pilot - can edit services -->
        <div v-else-if="profile.expert_profile.is_pilot" class="bg-green-50 p-4 rounded-lg border border-green-200">
          <p class="text-green-800 font-semibold mb-4">✓ Статус пилота подтвержден</p>

          <div class="mb-4">
            <label class="block mb-1 text-sm font-medium text-gray-900">Категория пилота</label>
            <p class="text-gray-700">{{ pilotCategoryLabel || '—' }}</p>
          </div>

          <div v-if="profile.expert_profile.pilot_certificate" class="mb-4">
            <label class="block mb-1 text-sm font-medium text-gray-900">Сертификат пилота</label>
            <a
              :href="profile.expert_profile.pilot_certificate"
              target="_blank"
              rel="noopener"
              class="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-200 text-blue-700 rounded hover:bg-blue-100 transition"
            >
              📄 Скачать сертификат
            </a>
          </div>

          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium text-gray-900">Виды услуг пилота</label>
            <div class="space-y-2">
              <div v-for="service in availablePilotServices" :key="service.value">
                <label class="flex items-center">
                  <input
                    type="checkbox"
                    :value="service.value"
                    v-model="profile.expert_profile.pilot_services"
                    class="rounded"
                  />
                  <span class="ml-2 text-gray-700">{{ service.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-6 flex justify-center gap-4">
        <button
          type="submit"
          :disabled="expertTextHasErrors"
          :class="[
            'bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg shadow',
            expertTextHasErrors && 'opacity-50 cursor-not-allowed hover:bg-blue-600'
          ]"
        >
          Сохранить
        </button>
        <router-link
          v-if="user.role.key === 0 || user.role.key === 3"
          to="/admin"
          class="bg-gray-700 hover:bg-gray-800 text-white font-semibold py-2 px-6 rounded-lg shadow inline-flex items-center"
        >
          Админ-панель
        </router-link>
      </div>
    </form>

    <div
      v-if="showSuccessModal"
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-[10010]"
    >
      <div class="bg-white rounded-lg shadow-lg px-8 py-6 text-center">
        <div class="text-green-600 text-3xl mb-2">✔</div>
        <div class="text-lg font-semibold mb-2">Профиль успешно сохранён!</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_PROFILE, HEADERS_TOKEN_JSON_FILE, API_PILOT_SERVICES_PUBLIC, HEADERS_TOKEN_JSON } from '@/const/uri';
import { VueEditor } from "vue3-editor";
import { mapActions, mapState } from 'vuex';
import PasswordVisibilityToggle from "@/components/Forms/PasswordVisibilityToggle.vue";

export default {
  data() {
    return {
      profile: {
        fio: '',
        login: '',
        email: '',
        phone: '',
        birth_date: '',
        password: '',
        role: null,
        expert_profile: {
          bio: '',
          education: '',
          experience: '',
          content: '',
          preview_text: '',
          achievements: '',
          specialization: '',
          photo: null,
          is_pilot: false,
          is_pilot_pending_verification: false,
          pilot_category: '',
          pilot_services: [],
          pilot_certificate: null,
        },
      },
      showSuccessModal: false,
      photoFile: null,
      photoPreview: null,
      pilotVerificationData: {
        pilot_category: '',
      },
      pilotCertificateFile: null,
      availablePilotServices: [],
      showPassword: false,
      expertTextMaxLength: 5000,
      expertTextFields: [
        { key: 'education', label: 'Образование' },
        { key: 'bio', label: 'Биография' },
        { key: 'experience', label: 'Опыт' },
        { key: 'achievements', label: 'Достижения' },
        { key: 'content', label: 'Полное описание' },
      ],
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
    };
  },
  components: {
    VueEditor,
    PasswordVisibilityToggle,
  },
  mounted() {
    this.fetchPilotServices();
    this.fetchProfile();
  },
  computed: {
    ...mapState(['user']),
    pilotCategoryLabel() {
      const map = { first: 'Первая категория', second: 'Вторая категория', third: 'Третья категория', fourth: 'Четвёртая категория' };
      return map[this.profile.expert_profile?.pilot_category] || '';
    },
    expertTextHasErrors() {
      return this.expertTextFields.some(field => this.isExpertTextFieldInvalid(field.key));
    },
  },
  methods: {
    ...mapActions(['toggleAlert']),
    getExpertTextLength(field) {
      return String(this.profile.expert_profile?.[field] || '').length;
    },
    isExpertTextFieldInvalid(field) {
      return this.getExpertTextLength(field) > this.expertTextMaxLength;
    },
    getExpertTextError(field) {
      const length = this.getExpertTextLength(field);
      if (length <= this.expertTextMaxLength) return '';
      return `Введено ${length} из ${this.expertTextMaxLength} символов. Пожалуйста, сократите текст`;
    },
    getExpertTextFieldClass(field) {
      return [
        'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500',
        this.isExpertTextFieldInvalid(field) && 'border-red-500 bg-red-50 focus:border-red-500 focus:ring-red-500',
      ];
    },
    getExpertTextCounterClass(field) {
      return [
        'text-xs mt-1 text-right',
        this.isExpertTextFieldInvalid(field) ? 'text-red-500' : 'text-gray-500',
      ];
    },
    showExpertTextLimitAlert() {
      const invalidField = this.expertTextFields.find(field => this.isExpertTextFieldInvalid(field.key));
      if (!invalidField) return;

      this.toggleAlert({
        message: `${invalidField.label}: ${this.getExpertTextError(invalidField.key)}`,
        isError: true,
      });
    },
    flattenErrorMessages(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.flatMap(item => this.flattenErrorMessages(item));
      if (typeof value === 'object') return Object.values(value).flatMap(item => this.flattenErrorMessages(item));
      return [String(value)];
    },
    getApiErrorMessage(error, fallback) {
      const data = error.response?.data;
      const messages = this.flattenErrorMessages(data?.errors || data?.error || data?.detail || data);
      return messages.join('; ') || fallback;
    },
    async fetchPilotServices() {
      try {
        const response = await axios.get(API_PILOT_SERVICES_PUBLIC.list, { headers: HEADERS_TOKEN_JSON() });
        const services = response.data.data || [];
        this.availablePilotServices = services.map(service => ({
          value: service.key,
          label: service.name
        }));
      } catch (error) {
        console.error('Error fetching pilot services:', error);
        this.availablePilotServices = [
        ];
      }
    },
    async fetchProfile() {
      try {
        const response = await axios.get(API_PROFILE.list, {
          headers: HEADERS_TOKEN_JSON_FILE(),
        });

        if (response.data.code === 0) {
          this.profile = {
            ...this.profile,
            ...response.data.data,
            expert_profile: {
              ...this.profile.expert_profile,
              ...(response.data.data.expert_profile || {}),
            },
          };

          if (this.profile.expert_profile?.photo) {
            this.photoPreview = this.profile.expert_profile.photo;
          }
        }
      } catch (error) {
        console.error('Ошибка загрузки профиля:', error);
      }
    },
    handlePhotoUpload(event) {
      this.photoFile = event.target.files[0];
      if (this.photoFile) {
        this.photoPreview = URL.createObjectURL(this.photoFile);
      }
    },
    handlePilotCertificateUpload(event) {
      this.pilotCertificateFile = event.target.files[0];
    },
    async submitPilotVerification() {
      if (!this.pilotVerificationData.pilot_category) {
        alert('Выберите категорию пилота');
        return;
      }

      if (!this.pilotCertificateFile) {
        alert('Загрузите сертификат пилота');
        return;
      }

      const formData = new FormData();
      formData.append('expert_profile.is_pilot_pending_verification', 'true');
      formData.append('expert_profile.pilot_category', this.pilotVerificationData.pilot_category);
      formData.append('expert_profile.pilot_certificate', this.pilotCertificateFile);
      formData.append('expert_profile.pilot_services', JSON.stringify([]));

      try {
        await axios.post(API_PROFILE.list, formData, {
          headers: HEADERS_TOKEN_JSON_FILE(),
        });
        this.fetchProfile();
        alert('Запрос на проверку отправлен! Ожидайте подтверждения модератора.');
      } catch (error) {
        console.error('Ошибка отправки запроса:', error);
        alert('Не удалось отправить запрос');
      }
    },
    async saveProfile() {
      if (this.expertTextHasErrors) {
        this.showExpertTextLimitAlert();
        return;
      }

      const formData = new FormData();

      // USER
      formData.append('fio', this.profile.fio);
      formData.append('login', this.profile.login);
      formData.append('email', this.profile.email);
      formData.append('phone', this.profile.phone);
      formData.append('birth_date', this.profile.birth_date);
      if (this.profile.password) {
        formData.append('password', this.profile.password);
      }

      // EXPERT PROFILE
      formData.append('expert_profile.bio', this.profile.expert_profile.bio || '');
      formData.append('expert_profile.education', this.profile.expert_profile.education || '');
      formData.append('expert_profile.experience', this.profile.expert_profile.experience || '');
      formData.append('expert_profile.achievements', this.profile.expert_profile.achievements || '');
      formData.append('expert_profile.specialization', this.profile.expert_profile.specialization || '');
      if (this.photoFile) {
        formData.append('expert_profile.photo', this.photoFile);
      }
      formData.append('expert_profile.preview_text', this.profile.expert_profile.preview_text || '');
      formData.append('expert_profile.content', this.profile.expert_profile.content || '');

      if (this.profile.expert_profile.is_pilot && this.profile.expert_profile.pilot_services) {
        formData.append('expert_profile.pilot_services', JSON.stringify(this.profile.expert_profile.pilot_services));
      }
      try {
        await axios.post(API_PROFILE.list, formData, {
          headers: HEADERS_TOKEN_JSON_FILE(),
        });
        this.fetchProfile();
        this.showSuccessModal = true;
        setTimeout(() => {
          this.showSuccessModal = false;
        }, 2000);
      } catch (error) {
        console.error('Ошибка сохранения профиля:', error);
        this.toggleAlert({
          message: this.getApiErrorMessage(error, 'Не удалось сохранить профиль'),
          isError: true,
        });
      }
    }
  },
};
</script>

